'use client';
import React from 'react';
import { ConsultsProps } from './consults.props';
import { Button, Div, Media, Text } from '@pezeshk-book/ui-kit';
import { ConsultItemDesktop, ConsultItemMobile, ConsultItemTablet } from './consult-item';
import routes from '@routes';
import { Slider } from '@pezeshk-book/modules';
import getParseRoute from '@utils/helpers/parse-route';
import { useParams } from 'next/navigation';
import { LocaleTypes } from '@dictionaries-types';

const Consults = ({ data, desktopSlides, translate }: ConsultsProps) => {
  const { lang } = useParams<{lang: LocaleTypes}>();
  return (
    <>
      <Media at={'xs'} className={'flex-col'}>
        <Div className={'flex-col'}>
          <Div className={'flex flex-col mt-6 w-full items-center self-center'}>
            {data.map((item: any, index: any) => (
              <ConsultItemMobile
                rate={item?.score}
                key={`ConsultItemMobile${index}`}
                hashUserId={item?.route_key}
                title={item?.specialty_title}
                slug={item?.slug}
                name={item?.full_name}
                photo={item?.picture_affix}
                userServiceFee={item?.serviceFee?.data}
                translate={translate}
              />
            ))}
          </Div>
          <Button href={getParseRoute({ pathname: routes['route.users.index'], locale: lang })} className={'mt-8 w-32 self-center bg-white z-[4]'} variant={'outlined'}>
            <Text color={'inherit'} typography={'base'}>
              {translate.show_more}
            </Text>
          </Button>
        </Div>
      </Media>
      <Media at={'sm'} className={'flex-col'}>
        <Slider spaceBetween={15} infiniteLoop={true} rows={1} tabletSlides={4} slides={3}>
          {data.map((item: any, index: any) => (
            <ConsultItemTablet
              rate={item?.score}
              key={`ConsultItemTablet${index}`}
              hashUserId={item?.route_key_affix}
              title={item?.specialty_title}
              slug={item?.slug}
              name={item?.full_name || `${item.first_name} ${item.last_name}`}
              photo={item?.picture_affix}
              userServiceFee={item?.serviceFee?.data}
              translate={translate}
            />
          ))}
        </Slider>
      </Media>
      <Media greaterThan={'sm'} className={'flex-col'}>
        <Slider
          infiniteLoop={true}
          spaceBetween={15}
          rows={1}
          slides={desktopSlides}>
          {data.map((item: any, index: any) => (
            <ConsultItemDesktop
              key={`ConsultItemDesktop${index}`}
              hashUserId={item?.route_key_affix}
              title={item?.specialty_title}
              slug={item?.slug}
              name={item?.full_name || `${item.first_name} ${item.last_name}`}
              photo={item?.picture_affix}
              userServiceFee={item?.serviceFee?.data}
              provinceTitle={item?.province_title || translate.unknown}
              translate={translate}
            />
          ))}
        </Slider>
      </Media>
    </>
  );
};

export default Consults;
